import * as core from '../../../../../../../core'
import * as changeImpactTeam from '../change-impact-team'

export const RESOURCE = {
  payload: {
    description: 'HCM',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactTeam.RESOURCE.payload.partialId,
    }),
    id: 'HCM',
    name: 'HCM',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
